//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  methods: {
    onChange: function onChange() {
      var _this = this;

      Utils.type.ifObject(this.spec.onChange, function (onChange) {
        _this.$nextTick(function () {
          GLib.action.execute(onChange, _this);
        });
      });
    },
    updateValue: function updateValue(variable) {
      if (variable.value) {
        this.fieldModel = variable.value;
      }
    },
    activeClass: function activeClass(childView) {
      if (childView.view.includes("fields/radio") && this.fieldModel == childView.value) {
        return "radio--active";
      } else {
        return "";
      }
    }
  }
};